 $(document).ready(function() {
        $("#tab1").trigger("click");
        $("#tab_mobile1").trigger("click");
    });

    var tab1Show = [];
    var tab1Hide = [];

    var tab2Show = [];
    var tab2Hide = []

    var tab3Show = [];
    var tab3Hide = [];

    if (window.screen.width > 480){
        // 第一个页签显隐组件id
        tab1Show = ['downloadCenter-appAndClient'];
        tab1Hide =['customText','dc-productTypeTab','downloadCenter-productList'];

        // 第二个页签显隐组件id
        tab2Show = ['customText','dc-productTypeTab','downloadCenter-productList'];
        tab2Hide =['downloadCenter-appAndClient'];

        // 第散个页签显隐组件id
        tab3Show = [];
        tab3Hide =['downloadCenter-appAndClient','customText','dc-productTypeTab','downloadCenter-productList'];
    }

    if (window.screen.width <= 480){
        // 第一个页签显隐组件id
        tab1Show = ['downloadCenter-appAndClient-mobile'];
        tab1Hide =['customText-mobile','dc-productTypeTab_mobile','downloadCenter-productList-mobile'];

        // 第二个页签显隐组件id
        tab2Show = ['customText-mobile','dc-productTypeTab_mobile','downloadCenter-productList-mobile'];
        tab2Hide =['downloadCenter-appAndClient-mobile'];

        // 第散个页签显隐组件id
        tab3Show = [];
        tab3Hide =['downloadCenter-appAndClient-mobile','customText-mobile','dc-productTypeTab','downloadCenter-productList'];
    }


    function toggleTab(e,index){
        e.preventDefault();

        // 清除activeTab类名
        $(".tab").each(function (){
            $(this).removeClass("activeTab");
        })
        // 给被点击的tab添加activeTab类名
        $("#tab"+index).addClass("activeTab");

        var showList = [];
        var hideList = [];

        // 根据是第几个按钮进行对应组件的显隐
        switch (index){
            case 1:
                showList = tab1Show;
                hideList= tab1Hide;
                break;
            case 2:
                showList = tab2Show;
                hideList= tab2Hide;
                break;
            case 3:
                showList = tab3Show;
                hideList= tab3Hide;
                break;
        }

        showAndHide(showList,hideList);

        // 双页签问题解决
        if (index == 2){
            $("#productTypeLink1").trigger("click");
        }
    }

    function toggleTab_mobile(e,index){
        e.preventDefault();

        // 清除activeTab类名
        $(".tab_mobile").each(function (){
            $(this).removeClass("activeTab");
        })
        // 给被点击的tab添加activeTab类名
        $("#tab_mobile"+index).addClass("activeTab");

        var showList = [];
        var hideList = [];

        // 根据是第几个按钮进行对应组件的显隐
        switch (index){
            case 1:
                showList = tab1Show;
                hideList= tab1Hide;
                break;
            case 2:
                showList = tab2Show;
                hideList= tab2Hide;
                break;
            case 3:
                showList = tab3Show;
                hideList= tab3Hide;
                break;
        }

        showAndHide(showList,hideList);

        // 双页签问题解决
        if (index == 2 && window.screen.width > 480){
            $("#productTypeLink1").trigger("click");
        }else if (index == 2 && window.screen.width <= 480) {
            $("#productType-1").trigger('click');
        }
    }



    function showAndHide(showList,hideList){
        showList.forEach(name => {
            $("#"+name).show();
            $("."+name).show();

        });
        hideList.forEach(name => {
            $("#"+name).hide();
            $("."+name).hide();
        });



    }